<template>
  <div class="member detailsReport" v-loading="exploading" :element-loading-text="loadtxt">
    <div class="memberTop">
      <div class="memberInput">
        <ShowNavHead v-if="!hiddenleft" />
        <div class="flex" v-show="!hiddenleft">
          <div class="selectDate flex aic">
            <div class="flname">发生日期:&nbsp;&nbsp;&nbsp;&nbsp;</div>
            <div class="block">
              <el-date-picker v-model="listQuery.currmon" type="month" :picker-options="pickerOptions" :clearable="false" value-format="yyyy-MM" placeholder="请选择月份">
              </el-date-picker>
              <!-- <span style="margin:0 5px;display:inline-block;">-</span>
              <el-date-picker v-model="listQuery.strdatee" type="month" 
              :clearable="false" :picker-options="pickerOptionsEnd" value-format="yyyy-MM" placeholder="结束月份">
              </el-date-picker> -->
            </div>
            <el-input v-model="listQuery.custname" style="margin-left: 20px;" placeholder="请输入项目名称"></el-input>
            <el-input v-model="listQuery.strdep1" style="margin-left: 20px;" placeholder="请输入一级部门名称"></el-input>
            <el-input v-model="listQuery.strdep2" style="margin-left: 20px;" placeholder="请输入二级部门名称"></el-input>
          </div>
          <button class="exportButton" v-if="tableTitle.length>0" style="margin-left:10px;width: 65px;" @click="getTableHead()">搜索</button>
        </div>
      </div>
      <button class="exportButton" style="margin-right:15px;width: 65px;" @click="visibleExp = true" v-if="tableData.length>0">导出</button>
    </div>
    <div class="main-con">
      <div class="crumbs detailReport">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>报表</el-breadcrumb-item>
          <el-breadcrumb-item>利润报表</el-breadcrumb-item>
          <el-breadcrumb-item>利润明细表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="checkedgroup" v-if="!hiddenleft">
          <span class="flname">仅查看汇总：</span>
          <el-checkbox v-model="stronesum" @change="Summary">一级部门汇总</el-checkbox>
          <el-checkbox v-model="strtwosum" @change="Summary">二级部门汇总</el-checkbox>
          <el-checkbox v-model="strthreesum" @change="Summary">三级部门汇总</el-checkbox>
          <el-checkbox v-model="strprosum" @change="Summary">项目汇总</el-checkbox>
        </div>
      </div>
      <div class="basicTable1">
        <el-table :data="tableData" border v-loading="loading" :highlight-current-row="true" element-loading-spinner="el-icon-loading" element-loading-text="拼命加载中···" :max-height="tableHeight-200" style="width: 99%" :row-class-name="tableRowClassName" ref="detailReport">
          <template v-for="(item,index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit show-overflow-tooltip :key="index" :width="item.StrColumName=='二级部门' || item.StrColumName=='三级部门' ? '110px' : item.StrColumName.length<6 ? '100px' : item.StrColumName.indexOf('项目名称')>-1 ? '130px' : '120px' " align="center"
              :fixed="item.StrColumName=='一级部门' ||item.StrColumName=='二级部门' || item.StrColumName=='三级部门'|| item.StrColumName.indexOf('项目名称')>-1">
            </el-table-column>
          </template>
        </el-table>
        <div class="block">
          <el-pagination @current-change="changeBPage" :current-page.sync="listQuery.currpage" :page-size="listQuery.pagenum" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>

      <el-dialog title="报表导出" :visible.sync="visibleExp" width="384px">
        <el-form>
          <el-form-item label="是否带总计：">
            <!-- <el-select v-model="isWithTotal" placeholder="请选择">
              <el-option label="带总计导出" :value="0"></el-option>
              <el-option label="不带总计导出" :value="2"></el-option>
            </el-select> -->
            <el-radio v-model="isWithTotal" :label="0">带总计导出</el-radio>
            <el-radio v-model="isWithTotal" :label="2">不带总计导出</el-radio>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="visibleExp = false">取消</button>
          <button class="search" @click="exportreport()" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
    </div>
  </div>

</template>
    
<script>
import xz from "@/common";
export default {
  data() {
    return {
      loadtxt: '',
      hiddenleft: false,
      loading: false,
      tableHeight: 0,
      exploading: false,
      tableTitle: [],
      tableData: [],
      total: 0,
      stronesum: false,
      strtwosum: false,
      strthreesum: false,
      strprosum: false,
      visibleExp: false,
      isWithTotal: 0,
      role: localStorage.loginRoletype,
      listQuery: {
        custname: '',
        lvl: 1,
        strdep1: '',
        strdep2: '',
        checked: false,
        userid: Cookies.get("userid-b"),
        currmon: new Date().getFullYear() + '-' + (new Date().getMonth() < 10 ? '0' + new Date().getMonth() : new Date().getMonth()),
        // currmon: '2022-08',
        instcode: '',
        // strdatee: new Date().getFullYear() + '-' + (new Date().getMonth()),
        currpage: 1,
        pagenum: 200
      },
      isAdmPower: false, //是否有管理员权限
      // 禁用日期范围
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      pickerOptionsEnd: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
    };
  },
  async created() {
    if (this.$route.query && this.$route.query != undefined) {
      this.$route.query.custname ? this.listQuery.custname = this.$route.query.custname : '';
      this.$route.query.dep1 ? this.listQuery.strdep1 = this.$route.query.dep1 : '';
      this.$route.query.dep2 ? this.listQuery.strdep2 = this.$route.query.dep2 : '';
      this.$route.query.mon ? this.listQuery.currmon = this.$route.query.mon : '';
      this.$route.query.hiddenleft ? this.hiddenleft = this.$route.query.hiddenleft : '';
      this.$route.query.hiddenleft ? this.$store.commit('setHiddenLeft', true) : '';
    }
    if(new Date().getMonth()==0 && !this.$route.query.mon){
      this.listQuery.currmon = (new Date().getFullYear()-1) + '-' + 12
    }
    this.calHeight();
    this.judgePower();
    // this.getTableHead();
  },
  methods: {
    //判断是否有管理员权限
    judgePower() {
        let data = {
          currpage: 1,
          perpage: 1000,
          keyword: '',
          strWorkState: '',
          strstation: '',
          strorgancode: ''
        }
        xz.getauthUserBasicReport(data).then(res => {
          if (res.status == 'ok') {
            if(res.totalcount>0){
              let a = res.msg.some( ele => Cookies.get("userid-b") == ele.Userid
              )
              this.isAdmPower = a ?  true : false;
              this.isAdmPower ? this.listQuery.instcode = '0' : this.listQuery.instcode = localStorage.gancode;
              this.getTableHead();
            }
          } else {
            this.$message.error('获取权限出错')
          }
        })
      },
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      console.log('tableHeight', this.tableHeight)
    },
    tableRowClassName({ row, rowIndex }) {
      if ((row.StrObjName.indexOf('汇总') > -1 || row.StrDep1.indexOf('汇总') > -1 || row.StrDep2.indexOf('汇总') > -1 || row.StrDep3.indexOf('汇总') > -1) && !this.stronesum && !this.strtwosum && !this.strthreesum && !this.strprosum) {
        return 'total-row';
      }
    },
    getTableHead() {
      this.loading = true;
      let headData = {
        userid: Cookies.get("userid-b"),
        currpage: 1,
        pagenum: 100,
        currmon: this.listQuery.currmon
      }
      xz.gettestreport('rtnreporthead', 'RevexpDetails2', headData).then(res => {
        if (res.status == 'ok') {
          this.tableTitle = res.msg;
          this.getTableData();
        } else {
          this.tableTitle = [];
          this.loading = false;
        }
      })
    },
    getTableData() {
      this.loading = true;
      let listQuery = this.listQuery;
      this.$set(listQuery, 'stronesum', this.stronesum ? '汇总' : '');
      this.$set(listQuery, 'strtwosum', this.strtwosum ? '汇总' : '');
      this.$set(listQuery, 'strthreesum', this.strthreesum ? '汇总' : '');
      this.$set(listQuery, 'strprosum', this.strprosum ? '汇总' : '');
      xz.gettestreport('rtnreportdata', 'RevexpDetails2', listQuery).then(res => {
        if (res.status == 'ok' && res.msg.length > 0) {
          this.tableData = res.msg;
          this.total = res.msg[0].totalCount;
          this.loading = false;
        } else {
          this.tableData = [];
          this.total = 0;
          this.loading = false;
        }
      })
    },
    Summary() {
      this.getTableData();
      if (this.stronesum || this.strtwosum || this.strthreesum || this.strprosum) {
        // console.log('1',this.$refs.detailReport)
        this.$nextTick(() => {
          this.$refs.detailReport.bodyWrapper.scrollLeft = Number(this.$refs.detailReport.bodyWidth.replace('px', ''))
        })
      } else {
        this.$nextTick(() => {
          this.$refs.detailReport.bodyWrapper.scrollLeft = Number(this.$refs.detailReport.bodyWidth.replace('', 'px'))
        })
      }
    },
    //分页
    changeBPage(val) {
      this.listQuery.currpage = val;
      this.getTableData();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.listQuery.pagenum = val;
      this.listQuery.currpage = 1;
      this.getTableData();
    },
    exportreport() {
      let data = {
        currmon: this.listQuery.currmon,
        userid: Cookies.get("userid-b"),
        instcode: this.isAdmPower ? '0' : localStorage.gancode,
        custname: this.listQuery.custname,
        strdep1: this.listQuery.strdep1,
        strdep2: this.listQuery.strdep2,
        lvl: this.isWithTotal,
        currpage: 1,
        pagenum: 100000,
        stronesum: this.stronesum ? '汇总' : '',
        strtwosum: this.strtwosum ? '汇总' : '',
        strthreesum: this.strthreesum ? '汇总' : '',
        strprosum: this.strprosum ? '汇总' : ''
      }
      this.loadtxt = '正在导出···';
      this.exploading = true;
      this.visibleExp = false;
      xz.gettestreport('downloadreport', 'RevexpDetails2', data).then(res => {
        if (res.status == 'ok') {
          this.$router.push({
            path: '/exportRecordList'
          })
        } else {
          this.$message({
            message: "导出错误",
            type: "error"
          })
        }
        this.exploading = false;
      })
      // this.$router.push({
      //   path: '/employee-exportRecordList'
      // })
    },
  }
}

  </script>
  <style scoped>
.ftabs {
  background: #fff;
  width: 99%;
}
.crumbs {
  justify-content: flex-start;
}
.checkedgroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}
.flname {
  font-size: 13px;
}
</style>
    
  <style>
.detailsReport .ftabs .el-tabs__header {
  margin: 0;
}
.basicTable1 .el-table th.el-table__cell {
  background: #f5f7fa;
}
.basicTable1 .el-table .el-table__cell {
  padding: 8px 0;
}
.selectDate .el-input {
  width: 160px;
}
.selectDate .el-input__inner {
  height: 35px;
  line-height: 35px;
}
.el-table .total-row {
  /* background: rgb(255, 199, 206); */
  background: #f0f9eb;
  /* font-weight: 600; */
}
.el-table__body tr.hover-row > td.el-table__cell {
  background: none;
}
/* .el-table .hover-row{
  background: rgb(255, 199, 206)!important
} */
.detailReport .el-checkbox__label {
  line-height: 40px;
  font-size: 13px;
  padding-left: 6px;
}
.checkedgroup .el-checkbox {
  margin-right: 15px;
}
.detailReport .el-breadcrumb {
  line-height: 40px;
}
</style>